// Static catalog — bundled to eliminate loading flash
export const PERMIT_CATALOG = {
  "types": [
    {
      "id": "building_commercial",
      "label": "Building Permit (Commercial)",
      "category": "building",
      "description": "Ground-up commercial construction permit."
    },
    {
      "id": "tenant_improvement",
      "label": "Tenant Improvement (TI)",
      "category": "building",
      "description": "Interior build-out within an existing commercial shell."
    },
    {
      "id": "new_construction",
      "label": "New Construction",
      "category": "building",
      "description": "Greenfield commercial development."
    },
    {
      "id": "shell_core",
      "label": "Shell & Core",
      "category": "building",
      "description": "Base building shell prior to tenant build-outs."
    },
    {
      "id": "foundation",
      "label": "Foundation / Footing",
      "category": "building",
      "description": "Foundation-only or footing-only early-release permit."
    },
    {
      "id": "demolition",
      "label": "Demolition",
      "category": "building",
      "description": "Full or partial demolition permit."
    },
    {
      "id": "roofing",
      "label": "Roofing",
      "category": "building",
      "description": "Re-roof or new roof system."
    },
    {
      "id": "facade_exterior",
      "label": "Fa\u00e7ade / Exterior",
      "category": "building",
      "description": "Exterior facade modification or refresh."
    },
    {
      "id": "grading_site",
      "label": "Grading / Site Work",
      "category": "building",
      "description": "Grading, excavation, retaining walls, site preparation."
    },
    {
      "id": "electrical",
      "label": "Electrical Permit",
      "category": "mep",
      "description": "Service upgrade, panel changes, branch circuits."
    },
    {
      "id": "plumbing",
      "label": "Plumbing Permit",
      "category": "mep",
      "description": "Domestic water, waste, vent, and gas piping."
    },
    {
      "id": "mechanical_hvac",
      "label": "Mechanical / HVAC",
      "category": "mep",
      "description": "HVAC, ductwork, refrigeration, exhaust."
    },
    {
      "id": "deferred_submittal",
      "label": "Deferred Submittal",
      "category": "mep",
      "description": "Components deferred after main permit issuance (typically MEP)."
    },
    {
      "id": "fire_sprinkler",
      "label": "Fire Sprinkler",
      "category": "fire_safety",
      "description": "NFPA 13/13R/13D fire suppression system."
    },
    {
      "id": "fire_alarm",
      "label": "Fire Alarm",
      "category": "fire_safety",
      "description": "NFPA 72 fire detection and notification."
    },
    {
      "id": "fire_approval",
      "label": "Fire Approval / Fire Marshal Review",
      "category": "fire_safety",
      "description": "Fire Marshal plan review and operational permits."
    },
    {
      "id": "high_piled_storage",
      "label": "High-Piled Storage",
      "category": "fire_safety",
      "description": "IFC Chapter 32 \u2014 racking, commodity classification, in-rack sprinklers."
    },
    {
      "id": "hazmat",
      "label": "Hazardous Materials / HMMP",
      "category": "fire_safety",
      "description": "Hazmat business plans, MHE battery charging, flammable liquids."
    },
    {
      "id": "zoning_variance",
      "label": "Zoning Variance",
      "category": "planning",
      "description": "Variance from zoning requirements."
    },
    {
      "id": "conditional_use_permit",
      "label": "Conditional Use Permit (CUP)",
      "category": "planning",
      "description": "Use permitted only with discretionary approval."
    },
    {
      "id": "site_plan_review",
      "label": "Site Plan / Site Design Review",
      "category": "planning",
      "description": "Discretionary site plan approval."
    },
    {
      "id": "entitlements",
      "label": "Entitlements & Planning Approval",
      "category": "planning",
      "description": "Entitlement-level discretionary approvals."
    },
    {
      "id": "land_use",
      "label": "Land Use Permit",
      "category": "planning",
      "description": "Land use compliance / specific use authorization."
    },
    {
      "id": "change_of_use",
      "label": "Change of Use",
      "category": "planning",
      "description": "Occupancy/use change requiring code re-evaluation."
    },
    {
      "id": "drc_presentation",
      "label": "DRC Presentation",
      "category": "planning",
      "description": "Development Review Committee presentation support."
    },
    {
      "id": "ada_accessibility",
      "label": "ADA / Accessibility Compliance",
      "category": "accessibility",
      "description": "ADA path of travel, 20% rule, state amendments."
    },
    {
      "id": "coastal_development",
      "label": "Coastal Development Permit",
      "category": "specialty",
      "description": "Coastal Commission / coastal zone approvals."
    },
    {
      "id": "health_department",
      "label": "Health Department Approval",
      "category": "specialty",
      "description": "Plan check for restaurants, medical, pharmacy."
    },
    {
      "id": "liquor_license",
      "label": "Liquor License",
      "category": "specialty",
      "description": "ABC / state liquor license coordination."
    },
    {
      "id": "sign_permit",
      "label": "Sign Permit",
      "category": "specialty",
      "description": "Wall, monument, illuminated, or pylon signage."
    },
    {
      "id": "green_building",
      "label": "Green Building Approval",
      "category": "environmental",
      "description": "LEED, CALGreen, Energy Code compliance."
    },
    {
      "id": "stormwater_swppp",
      "label": "Stormwater / SWPPP",
      "category": "environmental",
      "description": "Stormwater pollution prevention plan, NPDES."
    },
    {
      "id": "sanitation_sewer",
      "label": "Sanitation / Sewer",
      "category": "environmental",
      "description": "Sewer connection, septic, sanitation district."
    },
    {
      "id": "cal_osha",
      "label": "Cal/OSHA Compliance",
      "category": "specialty",
      "description": "Permit-required workplace approvals in CA."
    },
    {
      "id": "special_events",
      "label": "Special Events Permit",
      "category": "specialty",
      "description": "LA County and city special events permitting."
    },
    {
      "id": "encroachment_row",
      "label": "Encroachment / Public ROW",
      "category": "specialty",
      "description": "Public right-of-way, sidewalk, curb cut, utility encroachment."
    },
    {
      "id": "certificate_of_occupancy",
      "label": "Certificate of Occupancy (C/O)",
      "category": "closeout",
      "description": "Final occupancy certification."
    },
    {
      "id": "plan_check",
      "label": "Plan Check / Plan Review",
      "category": "closeout",
      "description": "Standalone plan review prior to permit issuance."
    },
    {
      "id": "other",
      "label": "Other / Not Sure Yet",
      "category": "specialty",
      "description": "Custom permit type \u2014 describe in project notes."
    }
  ],
  "categories": {
    "building": "Building",
    "mep": "MEP",
    "fire_safety": "Fire & Life Safety",
    "planning": "Planning & Zoning",
    "accessibility": "Accessibility",
    "specialty": "Specialty",
    "environmental": "Environmental",
    "closeout": "Closeout"
  }
} ;
